import { NexxusDatabase } from '@infra/persistence/NexxusDatabase';
import { SalarieRepository } from '@infra/persistence/SalarieRepository';
import { BulletinRepository } from '@infra/persistence/BulletinRepository';
import { EcritureRepository } from '@infra/persistence/EcritureRepository';
import { FactureRepository } from '@infra/persistence/FactureRepository';
import { CentreAnalytiqueRepository } from '@infra/persistence/CentreAnalytiqueRepository';
import { gardeEcriturePeriodeCloturee } from '@infra/tenancy/ecriturePeriodeGuard';
import { TenantScopedRepository } from '@infra/tenancy/TenantScopedRepository';
import type { Salarie } from '@shared/types/Salarie';
import type { Bulletin } from '@shared/types/Bulletin';
import type { Ecriture } from '@shared/types/Ecriture';
import type { Facture } from '@shared/types/Facture';
import type { CentreAnalytique } from '@shared/types/CentreAnalytique';
import type { IPersistencePort } from '@infra/persistence/IPersistencePort';

/** Persistance locale Dexie — mode hors connexion. */
export class LocalRepositoriesAdapter implements IPersistencePort {
  readonly dataMode = 'LOCAL_OFFLINE' as const;
  readonly salaries: TenantScopedRepository<Salarie>;
  readonly bulletins: TenantScopedRepository<Bulletin>;
  readonly ecritures: TenantScopedRepository<Ecriture>;
  readonly factures: TenantScopedRepository<Facture>;
  readonly centresAnalytiques: TenantScopedRepository<CentreAnalytique>;

  constructor(db: NexxusDatabase) {
    this.salaries = new TenantScopedRepository(new SalarieRepository(db), 'salaries');
    this.bulletins = new TenantScopedRepository(new BulletinRepository(db), 'bulletins');
    this.ecritures = new TenantScopedRepository(
      new EcritureRepository(db),
      'ecritures',
      gardeEcriturePeriodeCloturee,
    );
    this.factures = new TenantScopedRepository(new FactureRepository(db), 'factures');
    this.centresAnalytiques = new TenantScopedRepository(
      new CentreAnalytiqueRepository(db),
      'centres-analytiques',
    );
  }

  isRemoteOnline(): boolean {
    return true;
  }

  describe() {
    return {
      dataMode: this.dataMode,
      engine: 'dexie' as const,
      dexiePrimary: true,
    };
  }
}
